import React, { useEffect, useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';

export default function Confirmation({show, setShow, title, message, aceptAction, cancelAction}: any) { 
  return (
    <>
      <MDBModal open={show} tabIndex='-1' style={show?{opacity: 1, display: 'flex'}:{opacity: 0, display: 'none'}}>
        <MDBModalDialog style={{transform:"translate(0, 0vh)", margin: "auto"}}>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{title}</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={()=>cancelAction()}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>{message}</MDBModalBody>

            <MDBModalFooter style={{justifyContent: 'space-evenly'}}>
              <MDBBtn color='secondary' onClick={()=>{cancelAction()}}>
                Cancelar
              </MDBBtn>
              <MDBBtn onClick={()=>{aceptAction()}}>
                Aceptar
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}